"use client";
import { Link, usePathname } from "@/i18n/routing";
import { Button } from "@heroui/react";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

export default function NavbarLoginRegister() {
  const t = useTranslations();
  const pathname = usePathname();
  const isHide = useMemo(() => {
    switch (pathname) {
      case "/login":
      case "/register":
        return true;
      default:
        return false;
    }
  }, [pathname]);

  return (
    <>
      {isHide ? (
        <></>
      ) : (
        <>
          <Button as={Link} href="/login" className="w-32 border-none p-1 font-bold gradient-secondary">
            {t("login")}
          </Button>
          <Button as={Link} href="/register" color="primary" className="w-32 border-none p-1 font-bold">
            {t("register")}
          </Button>
        </>
      )}
    </>
  );
}
